import yieldLadder from './yieldLadder.zh'
import whitepaper from './whitepaper.zh'
import rulesSecurity from './rulesSecurity.zh'

export default {
  lendingContent: {
    yieldLadder,
    whitepaper,
    rulesSecurity
  }
}
